import countriesEn from "./locales/en/countries.json";
import countriesFr from "./locales/fr/countries.json";
import countriesDe from "./locales/de/countries.json";
import countriesNl from "./locales/nl/countries.json";
import countriesEs from "./locales/es/countries.json";
import countriesIt from "./locales/it/countries.json";
import countriesPt from "./locales/pt/countries.json";
import countriesPl from "./locales/pl/countries.json";

export interface CountryOption {
  code: string;
  name: string;
  label: string;
}

const countriesMap: Record<string, Record<string, string>> = {
  en: countriesEn,
  fr: countriesFr,
  de: countriesDe,
  nl: countriesNl,
  es: countriesEs,
  it: countriesIt,
  pt: countriesPt,
  pl: countriesPl,
};

export const getFlagEmoji = (countryCode: string): string => {
  return countryCode
    .toUpperCase()
    .split("")
    .map((char) => String.fromCodePoint(127397 + (char.codePointAt(0) ?? 0)))
    .join("");
};

export const getCountries = (locale: string = "en"): CountryOption[] => {
  const countries = countriesMap[locale] || countriesEn;

  return Object.entries(countries)
    .map(([code, name]) => ({
      code,
      name,
      label: `${getFlagEmoji(code)} ${name}`,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const getCountryName = (code: string, locale: string = "en"): string => {
  const countries = countriesMap[locale] || countriesEn;
  return countries[code] || "";
};
